<template>
    <div :ref="name ? name : undefined" :style="styles">
        <slot></slot>
    </div>
</template>
<script>
  function debounce(func, wait, immediate) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };
  };
  export default {
    name: 'parallax',
    props: {
      name: {
        type: String,
        default: null
      }
      },
    data() {
      return {
        styles: {},
        debounceTimeout: 6
      }
    },
    methods: {
      handleScroll(scrollVal) {
        let oVal = (scrollVal / 3);
        let name = this.name;
        let opacity = 1;
        let offset = 300;
        if ( name != null && name != undefined && this.$refs[name] && scrollVal >= offset ) {
        let height = this.$refs[name].clientHeight - offset;
        scrollVal = scrollVal - offset
        opacity = height - scrollVal <= 0 ? 0 : ((height - scrollVal) * (height - scrollVal)) / (height * height)
        }
        this.styles = {
          //transform: `translate3d(0, ${oVal}px,0)`,
          filter: `brightness(${opacity})`
        };
      },
      checkForParallax(scrollVal) {
        let fn = debounce(() => this.handleScroll(scrollVal), this.debounceTimeout);
        fn();
      },
      handleScrollEvent() {
      let container = document.getElementById('app')
        let scrollVal = container.scrollTop
       this.checkForParallax(scrollVal);
      },
    },
    mounted() {
      let self = this;
      let container = document.getElementById('app')
      self.container = container
      container.addEventListener("scroll", self.handleScrollEvent)
    },
    beforeDestroy() {
      let self = this;
      let container = document.getElementById('app');
      container.removeEventListener("scroll", self.handleScrollEvent)
    }
  }
</script>
<style>
.paralaxbackground {
background-color: black;
opacity: 0;
}
</style>
